module.exports = __webpack_public_path__ + "static/media/4-mobile.3ee2df9b.webp";